import React from 'react';
import { Box, createStyles, makeStyles } from '@material-ui/core';
import * as Colors from '../../theme/colors';
import BaseTypography from '../Text/BaseTypography';
import { ExtensionViewTypeValue } from '../Settings/ExtensionsPage/ExtensionViewType';

const useStyles = makeStyles(() =>
  createStyles({
    helperLabel: {
      color: Colors.GraySmall,
    },
  }),
);

interface ExtensionEmbedFieldLabelProps {
  newLineHelper?: boolean;
  extensionViewType?:
    | ExtensionViewTypeValue.EMBED
    | ExtensionViewTypeValue.LINK;
}

export const ExtensionEmbedFieldLabel: React.FC<ExtensionEmbedFieldLabelProps> = ({
  newLineHelper = false,
  extensionViewType,
}) => {
  const classes = useStyles();

  const labelDescription = React.useMemo(() => {
    if (extensionViewType === ExtensionViewTypeValue.LINK) {
      return 'Can be a public URL';
    }

    return 'Can be a public URL or iFrame';
  }, [extensionViewType]);

  return (
    <Box>
      <BaseTypography fontType="13Medium" component="span">
        Content
      </BaseTypography>
      <BaseTypography component="span" className={classes.helperLabel}>
        {newLineHelper ? <br /> : ' - '}
        {labelDescription}
      </BaseTypography>
    </Box>
  );
};
